import { render, staticRenderFns } from "./StockOrders.vue?vue&type=template&id=0f30e1b3"
import script from "./StockOrders.vue?vue&type=script&lang=js"
export * from "./StockOrders.vue?vue&type=script&lang=js"
import style0 from "./StockOrders.vue?vue&type=style&index=0&id=0f30e1b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports